"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.futuresPositionRawToPosition = exports.getFuturesOrderPrice = exports.futuresOrderRawToFuturesOrderMapper = exports.futuresMarkPriceUpdateRawToFuturesMarkPriceUpdate = exports.futuresAccountUpdateRawToFuturesAccountUpdate = void 0;
const binance_1 = require("../../types/binance");
const shared_1 = require("../data/shared");
const misc_1 = require("../misc");
const futuresAccountUpdateRawToFuturesAccountUpdate = (event) => {
    return {
        eventType: event.e,
        eventTime: event.E,
        transactionId: event.T,
        updateData: {
            updateEventType: event.a.m,
            updatedBalances: event.a.B.map(balanceRaw => {
                return {
                    asset: balanceRaw.a,
                    walletBalance: Number(balanceRaw.wb),
                    crossWalletBalance: Number(balanceRaw.cw),
                    balanceChange: Number(balanceRaw.bc),
                };
            }),
            updatedPositions: event.a.P.map(positionRaw => {
                return {
                    accumulatedRealisedPreFee: Number(positionRaw.cr),
                    entryPrice: Number(positionRaw.ep),
                    isolatedWalletAmount: Number(positionRaw.ep),
                    marginType: positionRaw.mt,
                    positionAmount: Number(positionRaw.pa),
                    positionSide: positionRaw.ps,
                    symbol: positionRaw.s,
                    unrealisedPnl: Number(positionRaw.up),
                };
            }),
        },
    };
};
exports.futuresAccountUpdateRawToFuturesAccountUpdate = futuresAccountUpdateRawToFuturesAccountUpdate;
const futuresMarkPriceUpdateRawToFuturesMarkPriceUpdate = (event) => {
    return {
        eventType: event.e,
        eventTime: event.E,
        symbol: event.s,
        markPrice: event.p,
        indexPrice: event.i,
        estimatedSettlePrice: event.P,
        fundingRate: event.r,
        nextFundingTime: event.T,
    };
};
exports.futuresMarkPriceUpdateRawToFuturesMarkPriceUpdate = futuresMarkPriceUpdateRawToFuturesMarkPriceUpdate;
const futuresOrderRawToFuturesOrderMapper = (orderUpdate) => {
    return Object.assign(Object.assign({}, orderUpdate), { priceOutput: (0, exports.getFuturesOrderPrice)({
            type: orderUpdate.type,
            price: orderUpdate.price,
            activatePrice: orderUpdate.activatePrice,
            stopPrice: orderUpdate.stopPrice
        }) });
};
exports.futuresOrderRawToFuturesOrderMapper = futuresOrderRawToFuturesOrderMapper;
const getFuturesOrderPrice = (params) => {
    const stopPriceTypes = [binance_1.EFuturesOrderType.STOP, binance_1.EFuturesOrderType.STOP_MARKET, binance_1.EFuturesOrderType.TAKE_PROFIT, binance_1.EFuturesOrderType.TAKE_PROFIT_MARKET];
    const activatePriceTypes = [binance_1.EFuturesOrderType.TRAILING_STOP_MARKET];
    switch (true) {
        case stopPriceTypes.includes(params.type):
            return params.stopPrice;
        case activatePriceTypes.includes(params.type):
            return params.activatePrice;
        default:
            return params.price;
    }
};
exports.getFuturesOrderPrice = getFuturesOrderPrice;
const futuresPositionRawToPosition = (params) => {
    const { positionRaw, exchangeInfo } = params;
    const symbolInfo = (0, misc_1.filterExchageInfoBySymbol)({
        symbol: positionRaw.symbol,
        exchangeInfo: exchangeInfo
    });
    const positionSideOutput = (0, misc_1.getPositionSideForView)(positionRaw.positionSide, positionRaw.positionAmt);
    return Object.assign(Object.assign({}, positionRaw), { uid: (0, misc_1.createPositionId)({
            side: positionRaw.positionSide,
            symbol: positionRaw.symbol
        }), unrealizedPnl: positionRaw.unRealizedProfit, quoteAsset: (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteAsset) || '', baseAsset: (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseAsset) || '', positionSideOutput: positionSideOutput, unrealizedPnlPercent: shared_1.FuturesDataUtils.calcUnPnlPercent({
            entryPrice: positionRaw.entryPrice,
            positionAmount: positionRaw.positionAmt,
            unrealisedPnl: positionRaw.unRealizedProfit
        }).toString(), adl: 0 });
};
exports.futuresPositionRawToPosition = futuresPositionRawToPosition;
